module.exports = __webpack_public_path__ + "static/media/cauliflower.105ba8d2.gif";